<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Manage Division</h2>
            </div>
        </div>
        <a-card class="mb-4">
            <h5 class="mb-3">Filter by</h5>
            <a-form :form="form"  @submit="searchHandel">
                <div class="row">
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-input size="large"
                                v-decorator="['name_en', { rules: [{ required: false }] }]"
                                placeholder="Search by name(en)"
                            />
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-input size="large"
                                v-decorator="['name_bn', { rules: [{ required: false }] }]"
                                placeholder="Search by name(bn)"
                            />
                        </a-form-item>
                    </div>
                    <div class="mb-4 col-md-3">
                        <a-form-item>
                            <a-select size="large"
                                v-decorator="[ 'status',
                                    { rules: [{ required: false}] },
                                ]"
                                placeholder="Search by status"
                            >
                                <a-select-option value="1">
                                    Active
                                </a-select-option>
                                <a-select-option value="0">
                                    Inactive
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>

                    <div class="col-md-12 text-right">
                            <a-button type="primary" class="btn btn-secondary rounded font-md mr-2" size="large" @click="resetFilter">
                                Reset
                            </a-button>
                            <a-button type="primary" class="btn btn-xs rounded font-md" size="large" html-type="submit">
                                Filter
                            </a-button>
                    </div> 
                </div>
            </a-form>
        </a-card>

        <a-card>
            <a-table
                :columns="columns"
                :data-source="division"
                :pagination="{ pageSize: 10 }"
                :scroll="{ y: 900 }"
                rowKey="id"
            > <!-- x: 'calc(600px + 50%)', -->
            
            <span slot="status" slot-scope="text, record">
                {{record.status ? 'Active' : 'Inactive'}}
            </span>

            <span slot="action" slot-scope="text, record">
                <router-link :to="'/edit-division/'+ record.id" type="primary" class="btn btn-xs" size="small">
                    Edit
                </router-link>
            </span>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    import { DIVISION_LIST } from "../../../script/api";
    import { getData } from "../../../script/api-service";
    import {buildSearchQuery, checkUserPermission} from "../../../script/helper";

    const columns = [
        {
            title: 'Name (EN)',
            dataIndex: 'name_en',
        },
        {
            title: 'Name (BN)',
            dataIndex: 'name_bn',
        },
        {
            title: 'Status',
            key: 'status',
            width: 150,
            scopedSlots: { customRender: 'status' },
        },
        // {
        //     title: 'Created At',
        //     dataIndex: 'createdAt',
        // },
        {
            title: 'Action',
            key: 'action',
            scopedSlots: { customRender: 'action' },
        }
    ];

    export default {
        data() {
            return {
                columns,
                division: [],
                search: null,
                form: this.$form.createForm(this, { name: 'searchDivision' }),
            };
        },
        watch: {
            search: function (newVal, oldVal) {
                if (newVal || (!newVal && oldVal)) {
                    this.getDivisions(newVal);
                }
            },
        },
        methods: {
            async getDivisions(query) {
                let url = DIVISION_LIST;
                if (query) url = url + '?' + query;

                let res = await getData(url);

                if (res) {
                    let masterData = res.data?.data;
                    this.division = masterData || [];
                }
            },
            searchHandel(e) {
                e.preventDefault();
                this.form.validateFields( async(err, values) => {
                    if (!err) {
                        this.search = buildSearchQuery(values);
                    }
                })
            },
            resetFilter() {
                this.form.resetFields();
                this.search = ''
            }
        },
        mounted() {
            this.getDivisions();
            if (!checkUserPermission('update_division')) {
                this.columns.pop();
            }
        },
    };
</script>